import React, { createContext, useState, useEffect } from "react";
import { toAbsoluteUrl } from "./AssetHelpers";
import { useAuth } from "../../app/modules/auth";

type CompanyType = {
  company_logo: string;
};

type PropsCompanyContext = {
  logoImageState: CompanyType;
  setState: React.Dispatch<React.SetStateAction<CompanyType>>;
  setLogoImage: (imageUrl: string) => void;
};

const DEFAULT_VALUE: PropsCompanyContext = {
  logoImageState: {
    company_logo: toAbsoluteUrl("/media/logos/Logo1992.png"),
  },
  setState: () => {},
  setLogoImage: () => {},
};

const LogoImageContext = createContext<PropsCompanyContext>(DEFAULT_VALUE);

interface LogoImageProviderProps {
  children: React.ReactNode;
}

const LogoImageProvider: React.FC<LogoImageProviderProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const [logoImageState, setState] = useState<CompanyType>(
    DEFAULT_VALUE.logoImageState
  );
  // const pathUrl = process.env.AWS_S3_BUCKET_URL;
  const pathUrl = "https://companies-admin.aacceson.com/";

  useEffect(() => {
    if (currentUser?.company_logo) {
      const imageUrl = `${pathUrl}${currentUser.company_logo}`;

      setState((prev: any) => ({
        ...prev,
        company_logo: imageUrl,
      }));
    }
  }, [currentUser]);

  const setLogoImage = (imageUrl: string) => {
    const fullUrl = `${pathUrl}${imageUrl}`;

    setState((prev) => ({ ...prev, company_logo: fullUrl }));
  };

  return (
    <LogoImageContext.Provider
      value={{ logoImageState, setState, setLogoImage }}
    >
      {children}
    </LogoImageContext.Provider>
  );
};

export { LogoImageProvider, LogoImageContext };
